import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'fn-screen-resolution',
	templateUrl: './fn-screen-resolution.component.html',
	styleUrls: ['./fn-screen-resolution.component.scss'],
})
export class FnScreenResolutionComponent implements OnInit {
	constructor() {}
	@Input() innerWidth = 1280;
	@Input() innerHeight = 800;
	@Input() imageSrc =
		'https://agcdn.altametrics.com/hubworks_resources/pre_dev/images/common/screen-size.svg';

	ngOnInit() {
		this.checkResolution();
		window.addEventListener('resize', this.checkResolution);
	}

	checkResolution = () => {
		let isPopupShown = sessionStorage.getItem('popupShown') || false;
		if (window.innerWidth < this.innerWidth && !isPopupShown) {
			document.getElementById('resolution-popup').style.display = 'block';
		} else {
			document.getElementById('resolution-popup').style.display = 'none';
		}
	};

	closePopup() {
		document.getElementById('resolution-popup').style.display = 'none';
		sessionStorage.setItem('popupShown', 'true');
	}
}
